import type {
    CardPointeInquireResponseBody,
    CardPointeNormalizedGatewayTransactionDetails,
} from './cardpointe-transaction-details.types';

export const CardPointeTransactionStatusOutcome = {
    FOUND: 'found',
    MISSING: 'missing',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CardPointeTransactionStatusOutcome =
    (typeof CardPointeTransactionStatusOutcome)[keyof typeof CardPointeTransactionStatusOutcome];

export interface CardPointeTransactionStatusRequestPathParams {
    readonly orderid: string;
    readonly merchid: string;
    readonly set: '1';
}

export interface CardPointeTransactionStatusRequestDetails {
    readonly method: 'GET';
    readonly pathTemplate: '/cardconnect/rest/inquireByOrderid/{orderid}/{merchid}/{set}';
    readonly pathParams: CardPointeTransactionStatusRequestPathParams;
}

export interface CardPointeInquireByOrderIdResponseBody extends CardPointeInquireResponseBody {
    readonly orderId?: string;
}

export interface CardPointeNormalizedTransactionStatusLookupResult {
    readonly gateway_transaction_details: CardPointeNormalizedGatewayTransactionDetails;
}

export type CardPointeTransactionStatusResponseDetails =
    | {
          readonly outcome: typeof CardPointeTransactionStatusOutcome.FOUND;
          readonly httpStatus: 200;
          readonly rawDetails: CardPointeInquireByOrderIdResponseBody;
          readonly normalizedDetails: CardPointeNormalizedGatewayTransactionDetails;
      }
    | {
          readonly outcome: typeof CardPointeTransactionStatusOutcome.MISSING;
          readonly httpStatus: number;
          readonly rawDetails: unknown;
          readonly message: string;
      }
    | {
          readonly outcome: typeof CardPointeTransactionStatusOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly rawDetails: unknown;
          readonly message: string;
      };
